module.exports = __webpack_public_path__ + "img/error.a64c7d8d.svg";